export const common: Record<string, string> = {
  'Retry in seconds': 'Újrapróbálkozás ennyi másodperc múlva',
  'Request another code': 'Új kód kérése',
  'Change email': 'E-mail-cím módosítása',
  Description: 'Leírás',
  'Licence Control': 'Licenckezelő',
  Organisations: 'Szervezetek',
  Invitations: 'Meghívók',
  'Master data': 'Törzsadatok',
  Configuration: 'Konfiguráció',
  'Sign out': 'Kijelentkezés',
  'Signed in as': 'Bejelentkezve',
  'Send sign-in code': 'Bejelentkezési kód küldése',
  'Sign in': 'Bejelentkezés',
  Email: 'E-mail',
  'Six-digit code': 'Hatjegyű kód',
  'Sign-in code sent': 'A bejelentkezési kódot elküldtük az e-mail-címre.',
  'Restoring session…': 'Munkamenet visszaállítása…',
  'Use your individual organisation account.': 'Használja a saját szervezeti fiókját.',
  'Online licence administration': 'Online licenckezelés',
  Organisation: 'Szervezet',
  Start: 'Kezdet',
  Status: 'Állapot',
  Created: 'Létrehozva',
  Actions: 'Műveletek',
  Suspend: 'Felfüggesztés',
  Reactivate: 'Újraaktiválás',
  Edit: 'Szerkesztés',
  Cancel: 'Mégse',
  Delete: 'Törlés',
  'Device activations': 'Eszközaktiválások',
  'Company invitations and users': 'Vállalati meghívók és felhasználók',
  Role: 'Szerepkör',
  Name: 'Név',
  Customer: 'Ügyfél',
  'Select company': 'Válasszon vállalatot',
  'New company name': 'Új vállalat neve',
  'Working…': 'Folyamatban…',
  'Configuration editing requires an active Innozenit administrator account.':
    'A konfiguráció szerkesztéséhez aktív Innozenit rendszergazdai fiók szükséges.',
  'v29 keeps offline licence activation. Register an existing offline licence ID below; this does not issue or activate a licence.':
    'A v29 megtartja az offline licencaktiválást. Az alábbiakban meglévő offline licencazonosító regisztrálható; ez nem ad ki és nem aktivál licencet.',
  'Integration enabled': 'Integráció engedélyezve',
  'Delegated scopes': 'Delegált jogosultságok',
  Validate: 'Ellenőrzés',
  'Publish saved draft': 'Mentett piszkozat közzététele',
  'Existing offline licences': 'Meglévő offline licencek',
  'Offline licence ID (32 hexadecimal characters)': 'Offline licencazonosító (32 hexadecimális karakter)',
  'Register existing ID': 'Meglévő azonosító regisztrálása',
  'Published history': 'Közzétételi előzmények',
  'Export signed file': 'Aláírt fájl exportálása',
  'Copy to editor for a new revision': 'Másolás a szerkesztőbe új verzióhoz',
  'Draft version': 'Piszkozat verzió',
  'Published revision': 'Közzétett verzió',
  none: 'nincs',
  "No client secret or password belongs in this configuration. Register the app's package name and actual signing-certificate redirect in the customer's single-tenant public-client registration.":
    'Ehhez a konfigurációhoz nem tartozik kliens titok vagy jelszó. Az alkalmazás csomagnevét és a tényleges aláíró tanúsítvány átirányítását az ügyfél egybérlős nyilvános kliens regisztrációjában kell megadni.',
  'Discard unsaved configuration edits?': 'Elveti a nem mentett konfigurációs módosításokat?',
  'Publish this saved draft for every registered phone in this company? A destination change pauses existing sync until reviewed.':
    'Közzéteszi ezt a mentett piszkozatot a vállalat minden regisztrált telefonjára? A célhely módosítása a felülvizsgálatig szünetelteti a meglévő szinkronizációt.',
  'Destination list name': 'Céllista neve',
  'Site ID (optional cross-check)': 'Webhelyazonosító (opcionális ellenőrzés)',
  'List ID (optional cross-check)': 'Listaazonosító (opcionális ellenőrzés)',
  'Photo document-library drive ID (optional)': 'Fotó dokumentumtár meghajtóazonosító (opcionális)',
  'Photo folder': 'Fotómappa',
  'Operation failed': 'A művelet sikertelen',
  'Signed configuration exported. Import it on the phone with this offline licence.':
    'Az aláírt konfiguráció exportálva. Importálja a telefonon ezzel az offline licenccel.',
  'Draft saved. Phones receive only published revisions.':
    'Piszkozat mentve. A telefonok csak a közzétett verziókat kapják meg.',
  'Published. Export the profile or refresh it on configured phones.':
    'Közzétéve. Exportálja a profilt, vagy frissítse a konfigurált telefonokon.',
  Revision: 'Változat',
  Active: 'Aktív',
  Suspended: 'Felfüggesztett',
  Deleted: 'Törölve',
  Released: 'Felszabadított',
  Expired: 'Lejárt',
  OrganisationAdmin: 'Szervezeti adminisztrátor',
  Release: 'Felszabadítás',
  'Unable to sign in.': 'A bejelentkezés sikertelen.',
  'The sign-in code is invalid or expired.': 'A bejelentkezési kód hibás vagy lejárt.',
  'Access control': 'Jogosultságok',
  Administration: 'Adminisztráció',
  Administrator: 'Adminisztrátor',
  All: 'Összes',
  Annotations: 'Jelölések',
  Blueprints: 'Tervrajzok',
  CLOSED: 'Lezárva',
  Client: 'Megrendelő',
  Close: 'Bezárás',
  Comment: 'Megjegyzés',
  Dark: 'Sötét',
  Deadline: 'Határidő',
  Details: 'Részletek',
  EN: 'EN',
  HU: 'HU',
  'In Progress': 'Folyamatban',
  Inspector: 'Ellenőr',
  'Last modified': 'Módosítva',
  LicenceControlService: 'Licenckezelő',
  Light: 'Világos',
  'Loading…': 'Betöltés…',
  Location: 'Helyszín',
  'Mobile users': 'Mobil felhasználók',
  NORMAL: 'Normál',
  New: 'Új',
  Opened: 'Nyitott',
  'Progress %': 'Készültség %',
  Project: 'Projekt',
  Refresh: 'Frissítés',
  Restore: 'Visszaállítás',
  STAGING: 'TESZTRENDSZER',
  Save: 'Mentés',
  'Show deleted': 'Töröltek mutatása',
  'Sign in with your authorized web administration account.':
    'Jelentkezzen be webes jogosultsággal rendelkező fiókjával.',
  'Sync diagnostics': 'Szinkronizálás diagnosztikája',
  System: 'Rendszer',
  Theme: 'Megjelenés',
  Ticket: 'Hibajegy',
  Tickets: 'Hibajegyek',
  Tutorial: 'Útmutató',
  Type: 'Típus',
  Versions: 'Változatok',
  selected: 'kijelölve',
  '· p.': '· oldal:',
  '· rev.': '· változat:',
  CANCELLED: 'Leállítva',
  READY: 'Elkészült',
  ALL: 'Összes projekt',
  SELECTED: 'Kijelölt projektek',
  INSPECTOR: 'Ellenőr',
  ADMINISTRATOR: 'Adminisztrátor',
  Unknown: 'Ismeretlen',
  'No data.': 'Nincs adat.',
  Help: 'Súgó',
  'Help mode': 'Súgómód',
  'Help mode enabled. Select a control to read its help.': 'Súgómód: válasszon egy vezérlőt a leírásához.',
  'Close help': 'Súgó bezárása',
  'Unavailable project assignments must be removed before saving.':
    'Mentés előtt távolítsa el a nem elérhető projekt-hozzárendeléseket.',
  Reference: 'Hivatkozás',
  'The application is temporarily unavailable. Please contact your administrator.':
    'Az alkalmazás átmenetileg nem érhető el. Forduljon a rendszergazdához.',
  'Tax number': 'Adószám',
  Phone: 'Telefon',
  'Job title': 'Beosztás',
  'Contact name': 'Kapcsolattartó',
  'External key': 'Külső azonosító',
  'Parent location': 'Szülőhelyszín',
  'Template key': 'Sablonazonosító',
  'Hungarian name': 'Magyar név',
  'English name': 'Angol név',
  'Display code': 'Megjelenített kód',
  Generated: 'Létrehozva',
  Retired: 'Kivonva',
  'Original file name': 'Eredeti fájlnév',
  'Match status': 'Egyezés állapota',
  'Processing status': 'Feldolgozás állapota',
  Imported: 'Importálva',
  'Current revision': 'Aktuális változat',
  Model: 'Modell',
  'Search table…': 'Keresés a táblázatban…',
  'Export CSV': 'CSV exportálása',
  VALIDATING: 'Ellenőrzés alatt',
  PROCESSING: 'Feldolgozás alatt',
  COMPLETED: 'Befejezve',
  PENDING: 'Várakozik',
  ACTIVE: 'Aktív',
  INACTIVE: 'Inaktív',
  DELETED: 'Törölve',
  DRAFT: 'Piszkozat',
  PUBLISHED: 'Közzétéve',
  AREA: 'Terület',
  GROUP: 'Csoport',
  OTHER: 'Egyéb',
  WARNING: 'Figyelmeztetés',
  INFO: 'Tájékoztatás',
  DEBUG: 'Hibakeresés',
  OPEN: 'Nyitott',
  RESOLVED: 'Megoldva',
  WAITING: 'Várakozik',
  OrganisationMember: 'Szervezeti tag',
  Tutorials: 'Oktatóanyagok',
  'Admin site manual': 'Adminisztrációs felület kézikönyve',
  'Mobile application manual': 'Mobilalkalmazás kézikönyve',
  Article: 'Cikk',
  'Editor language': 'Szerkesztés nyelve',
  Hungarian: 'Magyar',
  Draft: 'Piszkozat',
  'An unexpected error occurred.': 'Váratlan hiba történt.',
  'Administration users': 'Adminisztrációs felhasználók',
  'Administration access': 'Adminisztrátori hozzáférés',
  'Remove admin access': 'Adminisztrátori hozzáférés eltávolítása',
  'Mobile member invitation': 'Mobil tagsági meghívó',
  'Delete revoked licence': 'Visszavont licenc törlése',
  'Only revoked licences can be deleted.': 'Csak visszavont licencek törölhetők.',
  'Organisation licence administrators can issue Enterprise licences only.':
    'A szervezeti licencadminisztrátorok csak Enterprise licenceket adhatnak ki.',
  'This account does not have access to the Licence Control administration site.':
    'Ez a fiók nem rendelkezik hozzáféréssel a Licence Control adminisztrációs felületéhez.',
  'This account does not have administration access to the organisation.':
    'Ez a fiók nem rendelkezik adminisztrációs hozzáféréssel a szervezethez.',
  'This account does not have the required administration role.':
    'Ez a fiók nem rendelkezik a szükséges adminisztrátori szerepkörrel.',
  Updated: 'Frissítve',
  Reports: 'Riportok',
  'Generate PDF': 'PDF készítése',
  'Generate DOCX': 'DOCX készítése',
  'Generate XLSX': 'XLSX készítése',
  CUSTOM: 'Egyéni',
  MATCHING: 'Egyeztetés alatt',
  INDEXING: 'Indexelés alatt',
  UNMATCHED: 'Nincs egyezés',
  PARTIALLY_MATCHED: 'Részleges egyezés',
  MATCHED: 'Egyezik',
};
